import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DadosEmpresaDetalharRoutingModule } from './dados-empresa-detalhar-routing.module';
import { DadosEmpresaDetalharComponent } from './dados-empresa-detalhar.component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { InputMaskModule } from 'primeng/inputmask';
import { DividerModule } from 'primeng/divider';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DropdownModule } from 'primeng/dropdown';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DialogModule } from 'primeng/dialog';


@NgModule({
  imports: [
    CommonModule,
    DadosEmpresaDetalharRoutingModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    MessagesModule,
    InputMaskModule,
    DividerModule,
    FormatPipeModule,
    ProgressSpinnerModule,
    DropdownModule,
    ImageCropperModule,
    DialogModule
  ],
  declarations: [
    DadosEmpresaDetalharComponent
  ]
})
export class DadosEmpresaDetalharModule { }
